module.exports = "/logo-horizontal-61e6b4d93cc9b51e8888d12949523c06.svg";